import { useEffect, useState } from 'react';
import { motion, useScroll } from 'motion/react';

const BREAK_POINT_HIDDEN = 100;
const BOTTOM_THRESHOLD = 0.95;
const PINNED_BREAKPOINT = 50;
const CLASS_PREFIXED = 'adaptable-header';
const PINNED = `${CLASS_PREFIXED}--pinned`;
const UNFIXED = `${CLASS_PREFIXED}--unfixed`;

const VARIANTS = {
	visible: { y: 0 },
	hidden: { y: '-100%' }
};

// const TRANSITION = { ease: [0.09, 0.81, 0.98, 0.32], duration: 0.1 };

const ScrollAdapt = ({
	children,
	forceVisible = false,
	custom = {},
	bottomThreshold = BOTTOM_THRESHOLD,
	breakPointHidden = BREAK_POINT_HIDDEN,
	variants = VARIANTS,
	className = '',
	...rest
}) => {
	const [hidden, setHidden] = useState(false);
	const [scrollState, setScrollState] = useState(PINNED);
	const { scrollY, scrollYProgress } = useScroll({ axis: 'y' });

	useEffect(() => {
		function toggleOnScroll() {
			if (scrollY.current > PINNED_BREAKPOINT) {
				setScrollState(UNFIXED);
			} else {
				setScrollState(PINNED);
			}
			if (
				scrollY?.current > breakPointHidden &&
				scrollY?.current > scrollY.prev &&
				scrollY.prev > 0 &&
				scrollYProgress?.current < bottomThreshold
			) {
				setHidden(true);
			} else {
				setHidden(false);
			}
		}
		const unsubscribeScrollElement = scrollYProgress.on('change', toggleOnScroll);

		return () => {
			unsubscribeScrollElement();
		};
	}, [bottomThreshold, breakPointHidden, scrollY, scrollYProgress, setHidden]);

	return (
		<motion.div
			variants={variants}
			animate={hidden && !forceVisible ? 'hidden' : 'visible'}
			custom={custom}
			className={`${className} ${CLASS_PREFIXED} ${scrollState}`}
			{...rest}
		>
			{children}
		</motion.div>
	);
};

export default ScrollAdapt;
